export default __webpack_public_path__ + "static/media/19.85e63fa0.jpg";